import React from 'react'
import OnboardingAddressInfoComponent from './onboarding-address-info.component';
import OnBoardingFounderDetailsComponent from './onboarding-founder-details';
import OnBoardingGSTandPANInfoComponent from './onboarding-gst-pan-info.component';
import OnBoardingCertificateInfoComponent from './onboarding-certificate-info.component';
import OnboardOrganizationInfoComponent from './onboarding-organization-details,component';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';



export default function OnBoardingBasicInfoComponent ({handleInnerbasicFormChange,handleFormChange,registeredAddress,gstInfo,handleFormGSTItemChange,handleFormAddressItemChange,handleInnerFormChange, subscriptionDetails}: any) {

  return (
    <>
<OnboardOrganizationInfoComponent
          handleFormChange={handleFormChange}
          subscriptionDetails={subscriptionDetails}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          />
<AccordionContainer
    child={
   
<OnboardingAddressInfoComponent
          handleFormAddressItemChange={handleFormAddressItemChange}
          registeredAddress={registeredAddress}
          />

    }
     expandedPanel="Registered Address"
  headerTitle="Registered Address"
    />
   
<OnBoardingFounderDetailsComponent
          handleFormChange={handleFormChange}
          subscriptionDetails={subscriptionDetails}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          />
 <OnBoardingGSTandPANInfoComponent
          
          subscriptionDetails={subscriptionDetails}
          handleFormChange={handleFormChange}
          gstInfo={gstInfo}
          handleFormGSTItemChange={handleFormGSTItemChange}
          />
          <OnBoardingCertificateInfoComponent
          handleFormChange={handleFormChange}
          subscriptionDetails={subscriptionDetails}
          />

    
        </>
  )
}